import React from 'react';
import { characterClasses } from '../../../data/guide/classes';
import { EntityImage } from '../../world/EntityImage';
import { imageEntryForClass } from '../../../utils/entityImages';
import type { ClassId } from '../../../types/progression';

/**
 * Selector de clase inicial. Cada jugador ve solo su recorrido.
 * La imagen es de la clase inicial (no de sus evoluciones) y no selecciona la clase al pulsarla:
 * se elige con el botón del nombre.
 */
export function ClassSelector({
  value,
  onChange
}: {
  value?: ClassId;
  onChange: (id: ClassId) => void;
}) {
  return <fieldset data-id="element-990" data-mp="1g7f5ipc86ihh">
      <legend className="text-sm font-semibold text-white" data-id="element-991" data-mp="12aa26x3wbxpx">Elige tu clase inicial</legend>
      <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4" data-id="element-992" data-mp="16bluxbi2gz2c">
        {characterClasses.map(c => {
        const active = value === c.id;
        return (
          // Toda la tarjeta selecciona la clase. La vista previa de la foto solo se activa con la clase ya elegida,
          // así tocar la foto de otra clase primero la selecciona (evita abrir la foto por error).
          <div key={c.id} onClick={() => !active && onChange(c.id)} className={`flex min-h-[56px] items-center gap-2.5 rounded-2xl border px-2.5 py-2 transition-colors duration-150 ${active ? 'border-[#D4AF37] bg-[#D4AF37]/15' : 'cursor-pointer border-white/10 bg-[#0A1628] hover:border-[#D4AF37]/40'}`} data-id="element-993" data-mp="3ha05c8tnupb3">
              <EntityImage entry={imageEntryForClass(c.id)} alt={c.base} name={c.base} lazy={false} kind="persona" preview={active} focusable={active} data-id="element-994" data-mp="33a7iiol98t8e" />
              <button type="button" aria-pressed={active} onClick={() => onChange(c.id)} className="flex min-h-[44px] min-w-0 flex-1 flex-col items-start justify-center text-left" data-id="element-995" data-mp="3d8exx2zwb38a">
                <span className={`block text-sm font-semibold leading-tight ${active ? 'text-[#D4AF37]' : 'text-white'}`} data-id="element-996" data-mp="shnvjm0zp2gz">{c.base}</span>
                <span className="block text-[11px] uppercase text-gray-500" data-id="element-997" data-mp="ni1ibcl5vm86">{c.baseAliases[0]}</span>
              </button>
            </div>
        );
      })}
      </div>
    </fieldset>;
}